<section class="finished-card">
	<div class="card shadow">
		<div class="card-body">
			<div class="intro">
				<!-- <h1 class="font-weight-bold p-1 text-center">Stemwijzer<br /><small>voor Jongeren</small></h1> -->
				<!-- <div id="logo_container"><img src="assets/stemwijzer-logo.png"></div> -->
				<p>Hey! Nieuwsgierig naar jouw politieke voorkeur? In maximaal 14 vragen weet je het antwoord. Hup, aan de slag!</p>

			</div>
			<div class="pb-4 row">
				<div class="form-group col-6">
					<label class="form-label" for="label"><small>Vul hieronder een uniek label in om de uitslagen later per klas of groep te bekijken:</small></label>
					<div class="position-relative"><input class="form-control form-control-sm" type="text" id="label" [(ngModel)]="clientCode" (ngModelChange)="formatInput($event)" placeholder="schoolnaam-klasnaam"/>	<i class="fas fa-tag" ></i></div>
					<small class="form-text text-muted">Bekijk de uitslag door achter de url het label te plakken: jongerenstemtest.nl/uitslag/<em>3a</em>.</small>	
				</div>
				<div class="col-6">
					<p><strong>Deze stemwijzer is anoniem.</strong> We slaan geen privacygevoelige gegevens op. We registreren alleen de uitslag, zonder ze aan een persoon te koppelen.</p>
				</div>
			</div>
			<div class="text-center">
				<button (click)="startQuestions()" class="btn btn-success btn-lg font-weight-bold">Starten</button>
				<p class="mt-2 rmBottom"><small><a href="https://over.methodem.nl/blog/gebruik-de-jongerenstemwijzer-van-methode-m~595/">Meer informatie voor docenten</a></small></p>
			</div>
		</div>   
	</div>  
</section>
